import { getBrowserInfo } from "@/utils/BrowserInfo";
import { pb } from "@/utils/PocketBaseAdapter";

export const logDebug = async (data: any) => {
  try {
    const browserInfo = await getBrowserInfo();
    await pb.collection("debugLogs").create({
      ...data,
      browser: browserInfo.browser,
      OS: browserInfo.os,
      userIP: browserInfo.ip,
    });
  } catch (error) {
    console.error(error);
  }
};
